import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * ProductLookCard - Individual product card in Shop the Look
 */
export default class ProductLookCard extends Base {
  /**
   * Selected state - Source de vérité pour l'état de sélection
   */
  isSelected = true;

  /**
   * Component Configuration
   */
  static config = {
    name: 'ProductLookCard',
    refs: ['btn', 'checkmark'],
    emits: ['clicked'],
  };

  /**
   * Handle button click
   */
  onBtnClick() {
    this.isSelected = !this.isSelected;

    toggleClass(this.$refs.checkmark, 'hidden', !this.isSelected);

    // Notify parent to update submit button state
    this.$emit('clicked');
  }

  /**
   * Get product price
   * @returns {number} Product price in cents
   */
  get price() {
    const button = this.$refs.btn;
    const price = button?.dataset.price;
    return price ? Number.parseInt(price, 10) : 0;
  }

  /**
   * Get product info for cart
   * @returns {object | null} Product info or null if not selected
   */
  get cartItem() {
    if (!this.isSelected) {
      return null;
    }

    const button = this.$refs.btn;
    const variantId = button?.dataset.variantId;

    if (!variantId) {
      return null;
    }

    return {
      id: Number.parseInt(variantId, 10),
      quantity: 1,
    };
  }
}
